export interface TipoAnexo {
  id: number,
  nome: string,
  tamanhoMaxBytes: number,
  quantidadeMaxima: number,
  extensoes: string[]
}

export const TIPO_ARQUIVO_FOTOS_ID = 8;
